import axios from "./api";

const KassaService = {

    /**
     * response looks like this
     * {
     *   "success": true,
     *   "data": [
     *     {
     *       "id": 1,
     *       "name": "Naqt",
     *       "created_at": null,
     *       "updated_at": null,
     *       "balance": 0
     *     },
     *     {
     *       "id": 2,
     *       "name": "Plastik",
     *       "created_at": null,
     *       "updated_at": null,
     *       "balance": 0
     *     },
     *     {
     *       "id": 3,
     *       "name": "Bank",
     *       "created_at": null,
     *       "updated_at": null,
     *       "balance": 0
     *     }
     *   ],
     *   "message": "Success"
     * }
     * @returns {Promise<any>}
     */
    async getKassaList() {
        try {
            const response = await axios.get('/kassa');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    },

    /**
     * response looks like this
     * {
     *   "success": true,
     *   "data": [
     *     {
     *       "id": 2,
     *       "kassa_id": 1,
     *       "user_id": 1,
     *       "transport_id": 1,
     *       "summa": 15000,
     *       "izoh": "To'lov uchun kirim",
     *       "foyda": 3000,
     *       "created_at": "2025-07-02 14:59:27",
     *       "updated_at": "2025-07-02 14:59:27",
     *       "user": "admin 998911157709",
     *       "transport": "Isuzu NQR 01A123BC",
     *       "kassa_kirim_id": "2",
     *       "kassa_chiqim_id": null,
     *       "balance": 15000
     *     },
     *     {
     *       "id": 3,
     *       "kassa_id": 1,
     *       "user_id": 1,
     *       "transport_id": 1,
     *       "summa": 5000,
     *       "izoh": "To'lov uchun kirim",
     *       "foyda": 3000,
     *       "created_at": "2025-07-02 14:59:46",
     *       "updated_at": "2025-07-02 14:59:46",
     *       "user": "admin 998911157709",
     *       "transport": "Isuzu NQR 01A123BC",
     *       "kassa_kirim_id": "3",
     *       "kassa_chiqim_id": null,
     *       "balance": 20000
     *     },
     *     {
     *       "id": 1,
     *       "kassa_id": 1,
     *       "user_id": 1,
     *       "transport_id": 1,
     *       "summa": -1000,
     *       "izoh": "100 litr benzin",
     *       "foyda": 20000,
     *       "created_at": "2025-07-02 15:00:02",
     *       "updated_at": "2025-07-02 15:00:02",
     *       "user": "admin 998911157709",
     *       "transport": "Isuzu NQR 01A123BC",
     *       "kassa_kirim_id": null,
     *       "kassa_chiqim_id": "1",
     *       "balance": 19000
     *     },
     *     {
     *       "id": 2,
     *       "kassa_id": 1,
     *       "user_id": 1,
     *       "transport_id": 1,
     *       "summa": -9000,
     *       "izoh": "100 litr benzin",
     *       "foyda": 20000,
     *       "created_at": "2025-07-02 15:00:13",
     *       "updated_at": "2025-07-02 15:00:13",
     *       "user": "admin 998911157709",
     *       "transport": "Isuzu NQR 01A123BC",
     *       "kassa_kirim_id": null,
     *       "kassa_chiqim_id": "2",
     *       "balance": 10000
     *     }
     *   ],
     *   "message": "Kassa topildi"
     * }
     * @returns {Promise<any>}
     */
    async getKassaKirimChiqimList(kassaId, dateDan, dateGacha, perPage, page) {
        try {
            const response = await axios.get('/kassa/'+kassaId, {
                params: {
                    from: dateDan,
                    to: dateGacha,
                    per_page: perPage,
                    page: page
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating profile';
        }
    }


}

export default KassaService;